export default __webpack_public_path__ + "static/media/twenty-six.a70b0c64.png";